/**
 * Permission names. Keys are the backend's names minus the `PERMISSION_` prefix,
 * so a name can be found in both repos.
 */
const permission = {
  ADMIN_LOGIN: 'admin-login',
  ATTRIBUTES_UPDATE: 'attributes:update',
  BAN_EMAILS: 'ban-emails',
  CATEGORIES_UPDATE: 'categories:update',
  CREATE_PASSWORD_RESET_LINK: 'customers:create-password-reset-link',
  CREDITS_UPDATE: 'credits:update',
  CUSTOMERS_MANAGE_CCPA: 'customers:manage-ccpa',
  CUSTOM_CONTENT_UPDATE: 'custom-content:update',
  FEATURED_ITEMS_UPDATE: 'featured-items:update',
  LOYALTY_NUMBER_UPDATE: 'loyalty_number:update',
  MASS_PRICE_CHANGE_UPDATE: 'mass-price-change:update',
  ORDERS_REFUND: 'orders:refund',
  PRODUCTS_UPDATE: 'products:update',
  PROMOTIONS_UPDATE: 'promotions:update',
  RECOMMENDED_PRODUCTS_UPDATE: 'recommended-products:update',
  REPORTS_READ: 'reports:read',
  ROLES_UPDATE: 'roles:update',
  STORES_CREATE: 'stores:create',
  STORES_INDEFINITELY_DISABLE_PRODUCTS: 'stores:indefinitely-disable-products',
  STORES_MANAGE_OFFLINE_RESTRICTION: 'stores:manage-offline-restriction',
  STORES_REFUND: 'stores:refund',
  STORES_UPDATE: 'stores:update',
  STORES_UPDATE_ALL: 'stores:update-all',
  STORES_UPDATE_HOURS: 'stores:update-hours',
  STORES_UPDATE_INVENTORY: 'stores:update-inventory',
  STORES_UPDATE_MENU: 'stores:update-menu',
  STORES_UPDATE_PARS: 'stores:update-pars',
  STORES_UPDATE_THROTTLING: 'stores:update-throttling',
  TAX_RATES_UPDATE: 'tax-rates:update',
  TRANSLATIONS_UPDATE: 'translations:update',
  USERS_UPDATE: 'users:update',
  USERS_UPDATE_EMAIL: 'users:update-email',
  USERS_UPDATE_MANAGER_APPROVAL_CODE: 'users:update-manager_approval_code',
  USERS_UPDATE_PHOTO: 'users:update-photo',
  VERTICAL_SCROLLS_UPDATE: 'vertical-scrolls:update',
} as const

export type PermissionName = (typeof permission)[keyof typeof permission]

export default permission
